export interface Country {
  country_cd: string
  country_nm: string
  continent_cd: string
  continent_nm: string
}

export default function () {
  const { locale } = useI18n()

  async function fetchCountries() {
    return await useAPI<Country[]>('/country/countries', {
      method: 'GET',
      query: {
        languageGbSn: locale.value,
      },
    })
  }

  return {
    fetchCountries,
  }
}
